import { render } from "./DispenserSettings.vue?vue&type=template&id=f271ae9a"
import script from "./DispenserSettings.vue?vue&type=script&lang=js"
export * from "./DispenserSettings.vue?vue&type=script&lang=js"

import "./DispenserSettings.vue?vue&type=style&index=0&id=f271ae9a&lang=css"
script.render = render

export default script